import { render, staticRenderFns } from "./CaseListItemComponent.vue?vue&type=template&id=807dd25c&scoped=true&"
import script from "./CaseListItemComponent.vue?vue&type=script&lang=js&"
export * from "./CaseListItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807dd25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
